import React, { Component } from 'react';
import './App.css';
import Navigation from './Navigation.js'
import Footer from './Footer.js'


class Contact extends Component {
  
  render() {
    return (
    <div>
        <header>
            <img src="/img/asphalt-driveway-calculator-logo.png" className="logo" alt="Asphalt Driveway Calculator" />
            <a href="/" className="logo-title">Asphalt Driveway Calculator</a>
            <nav className="menu">
                <Navigation />
            </nav>
        </header>
                <div className="section">
                <h1>Contact Us</h1>
                <p>If you have any questions or business inquiries, contact us at <b>contact@asphaltdrivewaycalculator.com</b></p>
                </div>
            <Footer />
         </div>
    );
  }
}

export default Contact;